import { APIWarningTypeResponseType } from "../../services/APIEarlyWarningService";
import { CustomWarningIcon, EarlWarningFLW, EarlWarningHRW, EarlWarningLIG, GUSWarningIcon, IconEarthquake, IconEWAirStrike, IconEWNuclear, IconHighWind, IconMarineWeather, IconTsunami, LandSlideLSW } from "../iconSet/IconSet";
import { AdministrativeLevels, EarlyWarningTypeTypes } from "./CreateWarningTypes";

export const earlyWarningTypes: EarlyWarningTypeTypes[] = [
    {
        wType: "HRW", 
        wDescription: "Heavy Rain Early Warning", 
        wName: "Heavy Rain Early Warning", 
        wCode:"LSW1",
        sDescription: "Prevailing showery condition in the Island is likely to continue  over the island. above 12.0 mm are likely at some places in Ambalangoda Division.",
        icon: <EarlWarningHRW width="5rem" color="var(--color-text)"/>,
        
    },
    {
        wType: "LSW", 
        wDescription: "Landslide Early Warning", 
        wName: "Landslide Early Warning",
        wCode:"LSW10", 
        sDescription: "Since the rainfall within the past 24 hours has exceeded 150mm, if the rain continues, evacuate to a safe location to avoid the risk of landslides, slope failures, rock falls, cutting failures and ground subsidence.",
        icon: <LandSlideLSW width="6rem" color="var(--color-text)"/>,
    },
    {
        wType: "FLW",
        wDescription: "Flood Early Warning",
        wName: "Flood Early Warning",
        wCode:"LSW12", 
        sDescription: "A flood early warning has been issued for the Attanagalu Oya Basin, and residents in those areas, as well as vehicle drivers passing through those areas, are requested to pay close attention in this regard.",
        icon: <EarlWarningFLW width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "LIG",
        wDescription: "Severe Lightning Early Waring",
        wName: "Severe Lightning Early Waring",
        wCode:"LSW13", 
        sDescription: "Thundershowers accompanied by severe lightning are likely to occur at several places in Northern Province. There may be temporary localized strong winds during thundershowers. General public is kindly requested to take adequate precautions to minimize damages caused by lightning activity.",
        icon: <EarlWarningLIG width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "HWN",
        wDescription: "High Wind Warning",
        wName: "High Wind Warning",
        wCode:"LSW3", 
        sDescription: "",
        icon: <IconHighWind width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "MWA",
        wDescription: "Marine Weather Warnings",
        wName: "Marine Weather Warnings",
        wCode:"LSW2", 
        sDescription: "",
        icon: <IconMarineWeather width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "NTW",
        wDescription: "Nuclear Threat Warnings",
        wName: "Nuclear Threat Warnings",
        wCode:"LSW1", 
        sDescription: "",
        icon: <IconEWNuclear width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "ASW",
        wDescription: "Air Strike Warnings",
        wName: "Air Strike Warnings",
        wCode:"LSW0", 
        sDescription: "",
        icon: <IconEWAirStrike width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "TW",
        wDescription: "Tsunami Warnings",
        wName: "Tsunami Warnings",
        wCode:"LSW2", 
        sDescription: "",
        icon: <IconTsunami width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "CUS",
        wDescription: "Custom Warnings",
        wName: "Custom Warnings",
        wCode:"CUS", 
        sDescription: "",
        icon: <CustomWarningIcon width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "GUS",
        wDescription: "Gust Warning",
        wName: "Gust Warning",
        wCode:"GUS", 
        sDescription: "",
        icon: <GUSWarningIcon width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "EQW",
        wDescription: "Earthquake",
        wName: "Earthquake",
        wCode:"EQW", 
        sDescription: "",
        icon: <IconEarthquake width="5rem" color="var(--color-text)"/>,
    },
]

export const earlyWarningTypes2: APIWarningTypeResponseType[] = [
    {
        hazardType: "HRW", 
        warningName: "Heavy Rain Early Warning",
        warningId: "LSW1",
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "LSW", 
        warningName: "Landslide Early Warning",
        warningId:"LSW10", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "FLW",
        warningName: "Flood Early Warning",
        warningId:"LSW12", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "LIG",
        warningName: "Severe Lightning Early Waring",
        warningId:"LSW13", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "HWN",
        warningName: "High Wind Warning",
        warningId:"LSW3", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "MWA",
        warningName: "Marine Weather Warnings",
        warningId:"LSW2", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "NTW",
        warningName: "Nuclear Threat Warnings",
        warningId:"LSW1", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "ASW",
        warningName: "Air Strike Warnings",
        warningId:"LSW0", 
        warningType: "WR",
        departments: "EWD"
    },
]

// Location data
export const sriLankaAdministrationLevel: AdministrativeLevels = {
    LK1: {
        name: "Western",
        adminLevel: "province",
        children: {
            LK11: {
                name: "Colombo",
                adminLevel: "district",
                children: {
                    LK1103: { name: "Colombo", adminLevel: "DS" },
                    LK1106: { name: "Kolonnawa", adminLevel: "DS" },
                    LK1109: { name: "Kaduwela", adminLevel: "DS" },
                    LK1112: { name: "Homagama", adminLevel: "DS" },
                    LK1115: { name: "Seethawaka", adminLevel: "DS" },
                    LK1118: { name: "Padukka", adminLevel: "DS" },
                    LK1121: { name: "Maharagama", adminLevel: "DS" },
                    LK1124: { name: "Sri Jayawardanapura Kotte", adminLevel: "DS" },
                    LK1127: { name: "Thimbirigasyaya", adminLevel: "DS" },
                    LK1130: { name: "Dehiwala", adminLevel: "DS" },
                    LK1131: { name: "Ratmalana", adminLevel: "DS" },
                    LK1133: { name: "Moratuwa", adminLevel: "DS" },
                    LK1136: { name: "Kesbewa", adminLevel: "DS" }
                }
            },
            LK12: {
                name: "Gampaha",
                adminLevel: "district",
                children: {
                    LK1227: { name: "Attanagalla", adminLevel: "DS" },
                    LK1209: { name: "Divulapitiya", adminLevel: "DS" },
                    LK1239: { name: "Biyagama", adminLevel: "DS" },
                    LK1230: { name: "Dompe", adminLevel: "DS" },
                    LK1224: { name: "Gampaha", adminLevel: "DS" },
                    LK1221: { name: "Ja Ela", adminLevel: "DS" },
                    LK1236: { name: "Kelaniya", adminLevel: "DS" },
                    LK1215: { name: "Minuwangoda", adminLevel: "DS" },
                    LK1212: { name: "Mirigama", adminLevel: "DS" },
                    LK1233: { name: "Mahara", adminLevel: "DS" },
                    LK1206: { name: "Katana", adminLevel: "DS" },
                    LK1203: { name: "Negombo", adminLevel: "DS" },
                    LK1218: { name: "Wattala", adminLevel: "DS" }
                }
            },
            LK13: {
                name: "Kalutara",
                adminLevel: "district",
                children: {
                    LK1333: { name: "Agalawatta", adminLevel: "DS" },
                    LK1306: { name: "Bandaragama", adminLevel: "DS" },
                    LK1324: { name: "Beruwala", adminLevel: "DS" },
                    LK1327: { name: "Dodangoda", adminLevel: "DS" },
                    LK1310: { name: "Ingiriya", adminLevel: "DS" },
                    LK1309: { name: "Horana", adminLevel: "DS" },
                    LK1312: { name: "Bulathsinhala", adminLevel: "DS" },
                    LK1321: { name: "Kalutara", adminLevel: "DS" },
                    LK1315: { name: "Madurawala", adminLevel: "DS" },
                    LK1330: { name: "Matugama", adminLevel: "DS" },
                    LK1303: { name: "Panadura", adminLevel: "DS" },
                    LK1336: { name: "Palindanuwara", adminLevel: "DS" },
                    LK1339: { name: "Walallawita", adminLevel: "DS" },
                    LK1318: { name: "Millaniya", adminLevel: "DS" }
                }
            }
        }
    }, 
    LK2: {
        name: "Central",
        adminLevel: "province",
        children: {
            LK21: {
                name: "Kandy",
                adminLevel: "district",
                children: {
                    LK2109: { name: "Akurana", adminLevel: "DS" },
                    LK2148: { name: "Deltota", adminLevel: "DS" },
                    LK2130: { name: "Gangawata Korale", adminLevel: "DS" },
                    LK2133: { name: "Harispattuwa", adminLevel: "DS" },
                    LK2134: { name: "Hatharaliyadda", adminLevel: "DS" },
                    LK2127: { name: "Kundasale", adminLevel: "DS" },
                    LK2106: { name: "Poojapitiya", adminLevel: "DS" },
                    LK2103: { name: "Tumpane", adminLevel: "DS" },
                    LK2154: { name: "Ganga Ihala Korale", adminLevel: "DS" },
                    LK2157: { name: "Pasbagekorale", adminLevel: "DS" },
                    LK2115: { name: "Panvila", adminLevel: "DS" },
                    LK2112: { name: "Pathadumbara", adminLevel: "DS" },
                    LK2145: { name: "Pathahewaheta", adminLevel: "DS" },
                    LK2136: { name: "Yatinuwara", adminLevel: "DS" },
                    LK2139: { name: "Udunuwara", adminLevel: "DS" },
                    LK2118: { name: "Ududumbara", adminLevel: "DS" },
                    LK2151: { name: "Udapalatha", adminLevel: "DS" },
                    LK2121: { name: "Minipe", adminLevel: "DS" },
                    LK2142: { name: "Doluwa", adminLevel: "DS" },
                    LK2124: { name: "Medadumbara", adminLevel: "DS" }
                }
            },
            LK22: {
                name: "Matale",
                adminLevel: "district",
                children: {
                    LK2221: { name: "Ambanganga", adminLevel: "DS" },
                    LK2206: { name: "Dambulla", adminLevel: "DS" },
                    LK2203: { name: "Galewela", adminLevel: "DS" },
                    LK2218: { name: "Matale", adminLevel: "DS" },
                    LK2224: { name: "Laggala", adminLevel: "DS" },
                    LK2209: { name: "Naula", adminLevel: "DS" },
                    LK2212: { name: "Pallepola", adminLevel: "DS" },
                    LK2230: { name: "Rattota", adminLevel: "DS" },
                    LK2215: { name: "Yatawatta", adminLevel: "DS" },
                    LK2227: { name: "Wilgamuwa", adminLevel: "DS" },
                    LK2233: { name: "Ukuwela", adminLevel: "DS" }
                }
            },
            LK23: {
                name: "Nuwara Eliya",
                adminLevel: "district",
                children: {
                    LK2315: { name: "Ambagamuwa", adminLevel: "DS" },
                    LK2306: { name: "Hanguranketa", adminLevel: "DS" },
                    LK2303: { name: "Kothmale", adminLevel: "DS" },
                    LK2312: { name: "Nuwara Eliya", adminLevel: "DS" },
                    LK2309: { name: "Walapane", adminLevel: "DS" }
                }
            }
        }
    },
    LK3: {
        name: "Southern",
        adminLevel: "province",
        children: {
            LK31: {
                name: "Galle",
                adminLevel: "district",
                children: {
                    LK3145: { name: "Akmeemana", adminLevel: "DS" },
                    LK3127: { name: "Baddegama", adminLevel: "DS" },
                    LK3106: { name: "Balapitiya", adminLevel: "DS" },
                    LK3103: { name: "Bentota", adminLevel: "DS" },
                    LK3139: { name: "Galle4Gravets", adminLevel: "DS" },
                    LK3134: { name: "Gonapinuwala", adminLevel: "DS" },
                    LK3133: { name: "Ambalangoda", adminLevel: "DS" },
                    LK3136: { name: "Hikkaduwa", adminLevel: "DS" },
                    LK3112: { name: "Elpitiya", adminLevel: "DS" },
                    LK3109: { name: "Karandeniya", adminLevel: "DS" },
                    LK3124: { name: "Nagoda", adminLevel: "DS" },
                    LK3121: { name: "Neluwa", adminLevel: "DS" },
                    LK3115: { name: "Niyagama", adminLevel: "DS" },
                    LK3130: { name: "Welivitiya-Divitura", adminLevel: "DS" },
                    LK3154: { name: "Habaraduwa", adminLevel: "DS" },
                    LK3118: { name: "Thawalama", adminLevel: "DS" },
                    LK3142: { name: "Bope-Poddala", adminLevel: "DS" },
                    LK3148: { name: "Yakkalamulla", adminLevel: "DS" }
                }
            },
            LK32: {
                name: "Matara",
                adminLevel: "district",
                children: {
                    LK3218: { name: "Akuressa", adminLevel: "DS" },
                    LK3215: { name: "Athuraliya", adminLevel: "DS" },
                    LK3245: { name: "Devinuwara", adminLevel: "DS" },
                    LK3248: { name: "Dikwella", adminLevel: "DS" },
                    LK3230: { name: "Hakmana", adminLevel: "DS" },
                    LK3227: { name: "Kaburupitiya", adminLevel: "DS" },
                    LK3242: { name: "Matara Four Gravets", adminLevel: "DS" },
                    LK3212: { name: "Mulatiyana", adminLevel: "DS" },
                    LK3224: { name: "Malimbada", adminLevel: "DS" },
                    LK3221: { name: "Welipitiya", adminLevel: "DS" },
                    LK3233: { name: "Kirinda Puhulwella", adminLevel: "DS" },
                    LK3206: { name: "Kotapola", adminLevel: "DS" },
                    LK3209: { name: "Pasgoda", adminLevel: "DS" },
                    LK3203: { name: "Pitabaddara", adminLevel: "DS" },
                    LK3236: { name: "Thihagoda", adminLevel: "DS" },
                    LK3239: { name: "Weligama", adminLevel: "DS" }
                }
            },
            LK33: {
                name: "Hambantota",
                adminLevel: "district",
                children: {
                    LK3315: { name: "Ambalantota", adminLevel: "DS" },
                    LK3318: { name: "Angunakolapelessa", adminLevel: "DS" },
                    LK3330: { name: "Beliatta", adminLevel: "DS" },
                    LK3312: { name: "Hambantota", adminLevel: "DS" },
                    LK3324: { name: "Katuwana", adminLevel: "DS" },
                    LK3327: { name: "Okewela", adminLevel: "DS" },
                    LK3306: { name: "Lunugamwehera", adminLevel: "DS" },
                    LK3303: { name: "Sooriyawewa", adminLevel: "DS" },
                    LK3309: { name: "Thissamaharama", adminLevel: "DS" },
                    LK3333: { name: "Tangalle", adminLevel: "DS" },
                    LK3321: { name: "Weeraketiya", adminLevel: "DS" },
                    LK3325: { name: "Walasmulla", adminLevel: "DS" }
                }
            }
        }
    },
    LK4: {
        name: "Northern",
        adminLevel: "province",
        children: {
            LK41: {
                // Jaffna District (LK41)
                name: "Jaffna",
                adminLevel: "district",
                children: {
                    LK4136: { name: "Jaffna", adminLevel: "DS" },
                    LK4133: { name: "Nallur", adminLevel: "DS" },
                    LK4103: { name: "Islands North (Kayts)", adminLevel: "DS" },
                    LK4139: { name: "Islands South (Velanai)", adminLevel: "DS" },
                    LK4104: { name: "Karainagar", adminLevel: "DS" },
                    LK4124: { name: "Vadamaradchchi East", adminLevel: "DS" },
                    LK4121: { name: "Vadamaradchchi South-West (Karaveddy)", adminLevel: "DS" },
                    LK4127: { name: "Vadamaradchi North (Point Pedro)", adminLevel: "DS" },
                    LK4118: { name: "Valikamam East (Kopay)", adminLevel: "DS" },
                    LK4112: { name: "Valikamam North (Thllippalai)", adminLevel: "DS" },
                    LK4115: { name: "Valikamam South (Uduvil)", adminLevel: "DS" },
                    LK4109: { name: "Valikamam South West (Sandilipay)", adminLevel: "DS" },
                    LK4106: { name: "Valikamam West (Chankanai)", adminLevel: "DS" },
                    LK4130: { name: "Thenmaradchi (Chavakachcheri)", adminLevel: "DS" }
                }
            },
            LK42: {
                // Mannar District (LK42)
                name: "Mannar",
                adminLevel: "district",
                children: {
                    LK4203: { name: "Mannar Town", adminLevel: "DS" },
                    LK4206: { name: "Manthai West", adminLevel: "DS" },
                    LK4209: { name: "Madhu", adminLevel: "DS" },
                    LK4212: { name: "Nanaddan", adminLevel: "DS" },
                    LK4215: { name: "Musali", adminLevel: "DS" }
                }
            },
            LK43: {
                // Vavuniya District (LK43)
                name: "Vavuniya",
                adminLevel: "district",
                children: {
                    LK4309: { name: "Vavuniya", adminLevel: "DS" },
                    LK4303: { name: "Vavuniya North", adminLevel: "DS" },
                    LK4306: { name: "Vavuniya South", adminLevel: "DS" },
                    LK4312: { name: "Vengalacheddikulam", adminLevel: "DS" }
                }
            },
            LK44: {
                // Mullaitivu District (LK44)
                name: "Mullaitivu",
                adminLevel: "district",
                children: {
                    LK4406: { name: "Manthai East", adminLevel: "DS" },
                    LK4415: { name: "Maritimepattu", adminLevel: "DS" },
                    LK4412: { name: "Oddusuddan", adminLevel: "DS" },
                    LK4403: { name: "Thunukkai", adminLevel: "DS" },
                    LK4418: { name: "Welioya", adminLevel: "DS" }
                }
            },
            LK45: {
                // Kilinochchi District (LK45)
                name: "Kilinochchi",
                adminLevel: "district",
                children: {
                    LK4506: { name: "Kandavalai", adminLevel: "DS" },
                    LK4509: { name: "Karachchi", adminLevel: "DS" },
                    LK4512: { name: "Poonakary", adminLevel: "DS" },
                    LK4503: { name: "Pachchilaipalli", adminLevel: "DS" }
                }
            }
        }
    },
    LK5: {
        name: "Eastern",
        adminLevel: "province",
        children: {
            LK51: {
                // Batticaloa District (LK51)
                name: "Batticaloa",
                adminLevel: "district",
                children: {
                    LK5112: { name: "Eravur Pattu", adminLevel: "DS" },
                    LK5115: { name: "Eravur Town", adminLevel: "DS" },
                    LK5124: { name: "Kattankudy", adminLevel: "DS" },
                    LK5118: { name: "Manmunai North", adminLevel: "DS" },
                    LK5127: { name: "Manmunai Pattu", adminLevel: "DS" },
                    LK5136: { name: "Manmunai South & Eruvil Pattu", adminLevel: "DS" },
                    LK5130: { name: "Manmunai South West", adminLevel: "DS" },
                    LK5121: { name: "Manmunai West", adminLevel: "DS" },
                    LK5133: { name: "Porativu Pattu", adminLevel: "DS" }
                }
            },
            LK52: {
                // Ampara District (LK52)
                name: "Ampara",
                adminLevel: "district",
                children: {
                    LK5215: { name: "Ampara", adminLevel: "DS" },
                    LK5233: { name: "Addalaichenai", adminLevel: "DS" },
                    LK5236: { name: "Akkaraipattu", adminLevel: "DS" },
                    LK5239: { name: "Alayadivembu", adminLevel: "DS" },
                    LK5203: { name: "Dehiattakandiya", adminLevel: "DS" },
                    LK5234: { name: "Irakkamam", adminLevel: "DS" },
                    LK5216: { name: "Navithanveli", adminLevel: "DS" },
                    LK5245: { name: "Tirukkovil", adminLevel: "DS" },
                    LK5218: { name: "Sammanthurai", adminLevel: "DS" },
                    LK5221: { name: "Kalmunai", adminLevel: "DS" },
                    LK5225: { name: "Sainthamaruthu", adminLevel: "DS" },
                    LK5227: { name: "Karaitivu", adminLevel: "DS" },
                    LK5230: { name: "Nintavur", adminLevel: "DS" },
                    LK5242: { name: "Damana", adminLevel: "DS" },
                    LK5206: { name: "Padiyathalawa", adminLevel: "DS" },
                    LK5209: { name: "Mahaoya", adminLevel: "DS" },
                    LK5212: { name: "Uhana", adminLevel: "DS" },
                    LK5248: { name: "Pottuvil", adminLevel: "DS" },
                    LK5251: { name: "Lahugala", adminLevel: "DS" }
                }
            },
            LK53: {
                // Trincomalee District (LK53)
                name: "Trincomalee",
                adminLevel: "district",
                children: {
                    LK5309: { name: "Gomarankadawala", adminLevel: "DS" },
                    LK5312: { name: "Morawewa", adminLevel: "DS" },
                    LK5321: { name: "Kantale", adminLevel: "DS" },
                    LK5324: { name: "Kinniya", adminLevel: "DS" },
                    LK5327: { name: "Muthur", adminLevel: "DS" },
                    LK5306: { name: "Kuchchaweli", adminLevel: "DS" },
                    LK5303: { name: "Padavi Sri Pura", adminLevel: "DS" },
                    LK5315: { name: "Town & Gravets", adminLevel: "DS" },
                    LK5318: { name: "Thambalagamuwa", adminLevel: "DS" },
                    LK5330: { name: "Seruvila", adminLevel: "DS" },
                    LK5333: { name: "Verugal", adminLevel: "DS" }
                }
            }
        }
    },
    LK6: {
        name: "North Western",
        adminLevel: "province",
        children: {
            LK61: {
                // Kurunegala District (LK61)
                name: "Kurunegala",
                adminLevel: "district",
                children: {
                    LK6184: { name: "Alawwa", adminLevel: "DS" },
                    LK6149: { name: "Bamunakotuwa", adminLevel: "DS" },
                    LK6112: { name: "Ambanpola", adminLevel: "DS" },
                    LK6109: { name: "Ehetuwewa", adminLevel: "DS" },
                    LK6106: { name: "Galgamuwa", adminLevel: "DS" },
                    LK6103: { name: "Giribawa", adminLevel: "DS" },
                    LK6133: { name: "Ganewatta", adminLevel: "DS" },
                    LK6130: { name: "Ibbagamuwa", adminLevel: "DS" },
                    LK6115: { name: "Kotawehera", adminLevel: "DS" },
                    LK6154: { name: "Kurunegala", adminLevel: "DS" },
                    LK6142: { name: "Bingiriya", adminLevel: "DS" },
                    LK6139: { name: "Kobeigane", adminLevel: "DS" },
                    LK6151: { name: "Maspotha", adminLevel: "DS" },
                    LK6160: { name: "Mawathagama", adminLevel: "DS" },
                    LK6124: { name: "Maho", adminLevel: "DS" },
                    LK6157: { name: "Mallawapitiya", adminLevel: "DS" },
                    LK6178: { name: "Pannala", adminLevel: "DS" },
                    LK6127: { name: "Polpitigama", adminLevel: "DS" },
                    LK6118: { name: "Rasnayakapura", adminLevel: "DS" },
                    LK6163: { name: "Rideegama", adminLevel: "DS" },
                    LK6166: { name: "Weerabugedara", adminLevel: "DS" },
                    LK6136: { name: "Wariyapola", adminLevel: "DS" },
                    LK6175: { name: "Udubaddawa", adminLevel: "DS" },
                    LK6169: { name: "Kuliyapitiya East", adminLevel: "DS" },
                    LK6172: { name: "Kuliyapitiya West", adminLevel: "DS" },
                    LK6148: { name: "Panduwasnuwara East", adminLevel: "DS" },
                    LK6145: { name: "Panduwasnuwara West", adminLevel: "DS" },
                    LK6181: { name: "Narammala", adminLevel: "DS" },
                    LK6187: { name: "Polgahawela", adminLevel: "DS" }
                }
            },
            LK62: {
                // Puttalam District (LK62)
                name: "Puttalam",
                adminLevel: "district",
                children: {
                    LK6224: { name: "Anamaduwa", adminLevel: "DS" },
                    LK6230: { name: "Arachchikattuwa", adminLevel: "DS" },
                    LK6203: { name: "Kalpitiya", adminLevel: "DS" },
                    LK6209: { name: "Karuwalagaswewa", adminLevel: "DS" },
                    LK6233: { name: "Chilaw", adminLevel: "DS" },
                    LK6236: { name: "Madampe", adminLevel: "DS" },
                    LK6218: { name: "Mundel", adminLevel: "DS" },
                    LK6221: { name: "Mahakumbukkadawala", adminLevel: "DS" },
                    LK6239: { name: "Mahawewa", adminLevel: "DS" },
                    LK6215: { name: "Puttalam", adminLevel: "DS" },
                    LK6227: { name: "Pallama", adminLevel: "DS" },
                    LK6248: { name: "Dankotuwa", adminLevel: "DS" },
                    LK6242: { name: "Nattandiya", adminLevel: "DS" },
                    LK6245: { name: "Wennappuwa", adminLevel: "DS" },
                    LK6206: { name: "Vanathavilluwa", adminLevel: "DS" },
                    LK6212: { name: "Nawagattegama", adminLevel: "DS" }
                }
            }
        }
    },
    LK7: {
        name: "North Central",
        adminLevel: "province",
        children: {
            LK71: {
                // Anuradhapura District (LK71)
                name: "Anuradhapura",
                adminLevel: "district",
                children: {
                    LK7127: { name: "Galenbidunuwewa", adminLevel: "DS" },
                    LK7121: { name: "Kahatagasdigiliya", adminLevel: "DS" },
                    LK7106: { name: "Kebithigollewa", adminLevel: "DS" },
                    LK7109: { name: "Medawachchiya", adminLevel: "DS" },
                    LK7112: { name: "Mahawilachchiya", adminLevel: "DS" },
                    LK7124: { name: "Horowpathana", adminLevel: "DS" },
                    LK7115: { name: "Nuwaragam Palatha Central", adminLevel: "DS" },
                    LK7133: { name: "Nuwaragam Palatha East", adminLevel: "DS" },
                    LK7136: { name: "Nachchaduwa", adminLevel: "DS" },
                    LK7130: { name: "Mihinthale", adminLevel: "DS" },
                    LK7139: { name: "Nochchiyagama", adminLevel: "DS" },
                    LK7142: { name: "Rajanganaya", adminLevel: "DS" },
                    LK7118: { name: "Rambewa", adminLevel: "DS" },
                    LK7145: { name: "Thambuththegama", adminLevel: "DS" },
                    LK7151: { name: "Thirappane", adminLevel: "DS" },
                    LK7148: { name: "Thalawa", adminLevel: "DS" },
                    LK7160: { name: "Ipalogama", adminLevel: "DS" },
                    LK7163: { name: "Galnewa", adminLevel: "DS" },
                    LK7166: { name: "Palagala", adminLevel: "DS" },
                    LK7154: { name: "Kekirawa", adminLevel: "DS" },
                    LK7157: { name: "Palugaswewa", adminLevel: "DS" }
                }
            },
            LK72: {
                // Polonnaruwa District (LK72)
                name: "Polonnaruwa",
                adminLevel: "district",
                children: {
                    LK7212: { name: "Dimbulagala", adminLevel: "DS" },
                    LK7218: { name: "Elahera", adminLevel: "DS" },
                    LK7203: { name: "Higurakgoda", adminLevel: "DS" },
                    LK7206: { name: "Medirigiriya", adminLevel: "DS" },
                    LK7209: { name: "Lankapura", adminLevel: "DS" },
                    LK7215: { name: "Thamankaduwa", adminLevel: "DS" },
                    LK7210: { name: "Welikanda", adminLevel: "DS" }
                }
            }
        }
    },
    LK8: {
        name: "Uva",
        adminLevel: "province",
        children: {
            LK81: {
                // Badulla District (LK81)
                name: "Badulla",
                adminLevel: "district",
                children: {
                    LK8121: { name: "Badulla", adminLevel: "DS" },
                    LK8133: { name: "Bandarawela", adminLevel: "DS" },
                    LK8136: { name: "Ella", adminLevel: "DS" },
                    LK8142: { name: "Haldummulla", adminLevel: "DS" },
                    LK8124: { name: "Hali-Ela", adminLevel: "DS" },
                    LK8139: { name: "Haputale", adminLevel: "DS" },
                    LK8112: { name: "Kandeketiya", adminLevel: "DS" },
                    LK8118: { name: "Passara", adminLevel: "DS" },
                    LK8103: { name: "Mahiyanganaya", adminLevel: "DS" },
                    LK8109: { name: "Meegahakiula", adminLevel: "DS" },
                    LK8115: { name: "Soranathota", adminLevel: "DS" },
                    LK8127: { name: "Uvaparanagama", adminLevel: "DS" },
                    LK8130: { name: "Welimada", adminLevel: "DS" },
                    LK8119: { name: "Lunugala", adminLevel: "DS" }
                }
            },
            LK82: {
                // Monaragala District (LK82)
                name: "Monaragala",
                adminLevel: "district",
                children: {
                    LK8218: { name: "Badalkumbura", adminLevel: "DS" },
                    LK8203: { name: "Bibile", adminLevel: "DS" },
                    LK8224: { name: "Buttala", adminLevel: "DS" },
                    LK8206: { name: "Madulla", adminLevel: "DS" },
                    LK8215: { name: "Monaragala", adminLevel: "DS" },
                    LK8233: { name: "Sevanagala", adminLevel: "DS" },
                    LK8212: { name: "Siyambalanduwa", adminLevel: "DS" },
                    LK8230: { name: "Thanamalwila", adminLevel: "DS" },
                    LK8227: { name: "Katharagama", adminLevel: "DS" },
                    LK8221: { name: "Wellawaya", adminLevel: "DS" },
                    LK8209: { name: "Medagama", adminLevel: "DS" },
                }
            }
        }
    },
    LK9: {
        name: "Sabaragamuwa",
        adminLevel: "province",
        children: {
            LK91: {
                // Ratnapura District (LK91)
                name: "Ratnapura",
                adminLevel: "district",
                children: {
                    LK9130: { name: "Ayagama", adminLevel: "DS" },
                    LK9118: { name: "Balangoda", adminLevel: "DS" },
                    LK9103: { name: "Eheliyagoda", adminLevel: "DS" },
                    LK9142: { name: "Godakawela", adminLevel: "DS" },
                    LK9115: { name: "Imbulpe", adminLevel: "DS" },
                    LK9139: { name: "Kahawattha", adminLevel: "DS" },
                    LK9133: { name: "Kalawana", adminLevel: "DS" },
                    LK9109: { name: "Kiriella", adminLevel: "DS" },
                    LK9136: { name: "Nivithigala", adminLevel: "DS" },
                    LK9124: { name: "Pelmadulla", adminLevel: "DS" },
                    LK9112: { name: "Ratnapura", adminLevel: "DS" },
                    LK9145: { name: "Weligepola", adminLevel: "DS" },
                    LK9127: { name: "Elapatha", adminLevel: "DS" },
                    LK9148: { name: "Embilipitiya", adminLevel: "DS" },
                    LK9151: { name: "Kolonna", adminLevel: "DS" },
                    LK9121: { name: "Opanayake", adminLevel: "DS" }
                }
            },
            LK92: {
                // Kegalle District (LK92)
                name: "Kegalle",
                adminLevel: "district",
                children: {
                    LK9209: { name: "Aranayake", adminLevel: "DS" },
                    LK9224: { name: "Bulathkohipitiya", adminLevel: "DS" },
                    LK9230: { name: "Dehiowita", adminLevel: "DS" },
                    LK9233: { name: "Deraniyagala", adminLevel: "DS" },
                    LK9215: { name: "Galigamuwa", adminLevel: "DS" },
                    LK9212: { name: "Kegalle", adminLevel: "DS" },
                    LK9206: { name: "Mawanella", adminLevel: "DS" },
                    LK9227: { name: "Yatiyantota", adminLevel: "DS" },
                    LK9218: { name: "Warakapola", adminLevel: "DS" },
                    LK9221: { name: "Ruwanwella", adminLevel: "DS" },
                    LK9203: { name: "Rambukkana", adminLevel: "DS" }
                }
            }
        }
    }
}

export const sriLankaSeaAdministrationLevel: AdministrativeLevels = {
    SAR1: {
        name: "Puttalam to Mannar",
        adminLevel: "sea",
    },
    SAR2: {
        name: "Mannar to Kankasanturai",
        adminLevel: "sea",
    },
    SAR3: {
        name: "Kankasanturai to Trincomalee",
        adminLevel: "sea",
    },
    SAR4: {
        name: "Batticaloe to trincomalee",
        adminLevel: "sea",
    },
    SAR5: {
        name: "Batticaloa to Pottuvil",
        adminLevel: "sea",
    },
    SAR6: {
        name: "Pottuvil to Hambantota",
        adminLevel: "sea",
    },
    SAR7: {
        name: "Hambantota to Galle",
        adminLevel: "sea",
    },
    SAR8: {
        name: "Galle to Colombo",
        adminLevel: "sea",
    },
    SAR9: {
        name: "Colombo to Puttalam",
        adminLevel: "sea",
    },
}

export const maldivesAdministrativeLevel: AdministrativeLevels = {
    // Haa Alifu Atoll (MV001)
    MV001: {
        name: "Haa Alifu",
        adminLevel: "atoll",
        children: {
            MV001001: { name: "Thuraakunu", adminLevel: "island" },
            MV001002: { name: "Uligamu", adminLevel: "island" },
            MV001003: { name: "Berinmadhoo", adminLevel: "island" },
            MV001005: { name: "Mulhadhoo", adminLevel: "island" },
            MV001006: { name: "Huvarafushi", adminLevel: "island" },
            MV001007: { name: "Ihavandhoo", adminLevel: "island" },
            MV001008: { name: "Kelaa", adminLevel: "island" },
            MV001009: { name: "Vashafaru", adminLevel: "island" },
            MV001010: { name: "Dhihdhoo", adminLevel: "island" },
            MV001011: { name: "Filladhoo", adminLevel: "island" },
            MV001012: { name: "Maarandhoo", adminLevel: "island" },
            MV001013: { name: "Thakandhoo", adminLevel: "island" },
            MV001014: { name: "Utheemu", adminLevel: "island" },
            MV001015: { name: "Muraidhoo", adminLevel: "island" },
            MV001016: { name: "Baarah", adminLevel: "island" },
            MV001018: { name: "Alidhoo", adminLevel: "island" },
            MV001019: { name: "Alidhuffarufinolhu", adminLevel: "island" },
            MV001024: { name: "Gaamathikulhudhoo", adminLevel: "island" },
            MV001032: { name: "Maafinolhu", adminLevel: "island" },
            MV001035: { name: "Manafaru", adminLevel: "island" },
            MV001037: { name: "Medhafushi", adminLevel: "island" },
            MV001039: { name: "Naridhoo", adminLevel: "island" },
            MV001042: { name: "Van'gaaru", adminLevel: "island" }
        }
    },
    // Haa Dhaalu Atoll (MV002)
    MV002: {
        name: "Haa Dhaalu",
        adminLevel: "atoll",
        children: {
            MV002003: { name: "Hanimaadhoo", adminLevel: "island" },
            MV002004: { name: "Finey", adminLevel: "island" },
            MV002005: { name: "Naivaadhoo", adminLevel: "island" },
            MV002006: { name: "Hirimaradhoo", adminLevel: "island" },
            MV002007: { name: "Nolhivaranfaru", adminLevel: "island" },
            MV002008: { name: "Nellaidhoo", adminLevel: "island" },
            MV002009: { name: "Nolhivaramu", adminLevel: "island" },
            MV002010: { name: "Kurin'bee", adminLevel: "island" },
            MV002012: { name: "Kulhudhuffushi", adminLevel: "island" },
            MV002013: { name: "Kumundhoo", adminLevel: "island" },
            MV002014: { name: "Neykurendhoo", adminLevel: "island" },
            MV002015: { name: "Vaikaradhoo", adminLevel: "island" },
            MV002017: { name: "Makunudhoo", adminLevel: "island" },
            MV002018: { name: "Dhipparufushi", adminLevel: "island" },
            MV002021: { name: "Hon'daafushi", adminLevel: "island" },
            MV002026: { name: "Kudafarufasgandu", adminLevel: "island" },
            MV002027: { name: "Kudamuraidhoo", adminLevel: "island" },
            MV002031: { name: "Muiri", adminLevel: "island" },
            MV002032: { name: "Naagoashi", adminLevel: "island" },
            MV002034: { name: "Theefaridhoo", adminLevel: "island" }
        }
    },
    // Shaviyani Atoll (MV003)
    MV003: {
        name: "Shaviyani",
        adminLevel: "atoll",
        children: {
            MV003001: { name: "Kan'ditheemu", adminLevel: "island" },
            MV003002: { name: "Noomaraa", adminLevel: "island" },
            MV003003: { name: "Goidhoo", adminLevel: "island" },
            MV003004: { name: "Feydhoo", adminLevel: "island" },
            MV003005: { name: "Feevah", adminLevel: "island" },
            MV003006: { name: "Bileiyfahi", adminLevel: "island" },
            MV003007: { name: "Foakaidhoo", adminLevel: "island" },
            MV003008: { name: "Narudhoo", adminLevel: "island" },
            MV003010: { name: "Maroshi", adminLevel: "island" },
            MV003011: { name: "Lhaimagu", adminLevel: "island" },
            MV003012: { name: "Firun'baidhoo", adminLevel: "island" },
            MV003013: { name: "Komandoo", adminLevel: "island" },
            MV003014: { name: "Maaun'goodhoo", adminLevel: "island" },
            MV003015: { name: "Funadhoo", adminLevel: "island" },
            MV003016: { name: "Milandhoo", adminLevel: "island" },
            MV003022: { name: "Dholhiyadhoo", adminLevel: "island" },
            MV003025: { name: "Ekasdhoo", adminLevel: "island" },
            MV003026: { name: "Eriadhoo", adminLevel: "island" },
            MV003028: { name: "Fushifaru", adminLevel: "island" },
            MV003029: { name: "Gaakoshibi", adminLevel: "island" },
            MV003032: { name: "Hurasfaru", adminLevel: "island" },
            MV003033: { name: "Kakaaeriyadhoo", adminLevel: "island" },
            MV003034: { name: "Kan'baalifaru", adminLevel: "island" },
            MV003035: { name: "Keekimini", adminLevel: "island" },
            MV003038: { name: "Kudalhaimendhoo", adminLevel: "island" },
            MV003047: { name: "Madidhoo", adminLevel: "island" },
            MV003048: { name: "Madikuredhdhoo", adminLevel: "island" },
            MV003050: { name: "Medhukun'burudhoo", adminLevel: "island" },
            MV003053: { name: "Naainfarufinolhu", adminLevel: "island" },
            MV003059: { name: "Van'garu", adminLevel: "island" }
        }
    },
    // Noonu Atoll (MV004)
    MV004: {
        name: "Noonu",
        adminLevel: "atoll",
        children: {
            MV004001: { name: "Hen'badhoo", adminLevel: "island" },
            MV004002: { name: "Ken'dhikulhudhoo", adminLevel: "island" },
            MV004003: { name: "Maalhendhoo", adminLevel: "island" },
            MV004004: { name: "Kudafari", adminLevel: "island" },
            MV004005: { name: "Landhoo", adminLevel: "island" },
            MV004006: { name: "Maafaru", adminLevel: "island" },
            MV004007: { name: "Lhohi", adminLevel: "island" },
            MV004008: { name: "Miladhoo", adminLevel: "island" },
            MV004009: { name: "Magoodhoo", adminLevel: "island" },
            MV004010: { name: "Manadhoo", adminLevel: "island" },
            MV004011: { name: "Holhudhoo", adminLevel: "island" },
            MV004012: { name: "Fohdhoo", adminLevel: "island" },
            MV004013: { name: "Velidhoo", adminLevel: "island" },
            MV004014: { name: "Ban'daidhihdhoo", adminLevel: "island" },
            MV004017: { name: "Bomasdhoo", adminLevel: "island" },
            MV004022: { name: "Dhigurah", adminLevel: "island" },
            MV004024: { name: "Ehdhuffarumairah", adminLevel: "island" },
            MV004025: { name: "Ekulhivaru", adminLevel: "island" },
            MV004027: { name: "Felivaru", adminLevel: "island" },
            MV004029: { name: "Fushivelavaru", adminLevel: "island" },
            MV004031: { name: "Huivani", adminLevel: "island" },
            MV004033: { name: "Huvan'dhumaavattaru", adminLevel: "island" },
            MV004042: { name: "Kudafunafaru", adminLevel: "island" },
            MV004043: { name: "Kudafushi", adminLevel: "island" },
            MV004044: { name: "Kunnamalei", adminLevel: "island" },
            MV004061: { name: "Loafaru", adminLevel: "island" },
            MV004064: { name: "Maakurehdhoo", adminLevel: "island" },
            MV004066: { name: "Maavelavaru", adminLevel: "island" },
            MV004067: { name: "Medhafushi", adminLevel: "island" },
            MV004068: { name: "Medhufaru", adminLevel: "island" },
            MV004069: { name: "Minaavaru", adminLevel: "island" },
            MV004071: { name: "Orivaru", adminLevel: "island" },
            MV004073: { name: "Raafushi", adminLevel: "island" },
            MV004074: { name: "Raalhulaakolhu", adminLevel: "island" },
            MV004075: { name: "Randheli", adminLevel: "island" },
            MV004076: { name: "Than'burudhoo", adminLevel: "island" },
            MV004077: { name: "Than'burudhuffushi", adminLevel: "island" },
            MV004079: { name: "Thoshigan'dukolhu", adminLevel: "island" },
            MV004080: { name: "Vavathi", adminLevel: "island" }
        }
    },
    // Lhaviyani Atoll (MV005)
    MV005: {
        name: "Lhaviyani",
        adminLevel: "atoll",
        children: {
            MV005001: { name: "Hinnavaru", adminLevel: "island" },
            MV005002: { name: "Naifaru", adminLevel: "island" },
            MV005003: { name: "Kurendhoo", adminLevel: "island" },
            MV005004: { name: "Olhuvelifushi", adminLevel: "island" },
            MV005006: { name: "Aligau", adminLevel: "island" },
            MV005009: { name: "Bodufinolhu", adminLevel: "island" },
            MV005012: { name: "Dheruffinolhu", adminLevel: "island" },
            MV005016: { name: "Faadhoo", adminLevel: "island" },
            MV005020: { name: "Felivaru", adminLevel: "island" },
            MV005025: { name: "Hudhufushi", adminLevel: "island" },
            MV005026: { name: "Huravalhi", adminLevel: "island" },
            MV005027: { name: "Innahuraa", adminLevel: "island" },
            MV005029: { name: "Kanifushi", adminLevel: "island" },
            MV005030: { name: "Kanuhuraa", adminLevel: "island" },
            MV005031: { name: "Komandoo", adminLevel: "island" },
            MV005032: { name: "Kudadhoo", adminLevel: "island" },
            MV005033: { name: "Kurehdhoo", adminLevel: "island" },
            MV005061: { name: "Lhohi", adminLevel: "island" },
            MV005063: { name: "Maabinhuraa", adminLevel: "island" },
            MV005065: { name: "Madhiriguraidhoo", adminLevel: "island" },
            MV005070: { name: "Medha Adihuraa", adminLevel: "island" },
            MV005074: { name: "Ookolhufinolhu", adminLevel: "island" },
            MV005076: { name: "Thilamaafushi", adminLevel: "island" },
            MV005080: { name: "Veyvah", adminLevel: "island" }
        }
    },
    // Raa Atoll (MV006)
    MV006: {
        name: "Raa",
        adminLevel: "atoll",
        children: {
            MV006001: { name: "Alifushi", adminLevel: "island" },
            MV006002: { name: "Vaadhoo", adminLevel: "island" },
            MV006003: { name: "Rasgetheemu", adminLevel: "island" },
            MV006004: { name: "An'golhitheemu", adminLevel: "island" },
            MV006005: { name: "Hulhudhuffaaru", adminLevel: "island" },
            MV006006: { name: "Un'goofaaru", adminLevel: "island" },
            MV006008: { name: "Maakurathu", adminLevel: "island" },
            MV006009: { name: "Rasmaadhoo", adminLevel: "island" },
            MV006010: { name: "Innamaadhoo", adminLevel: "island" },
            MV006011: { name: "Maduvvari", adminLevel: "island" },
            MV006012: { name: "In'guraidhoo", adminLevel: "island" },
            MV006013: { name: "Fainu", adminLevel: "island" },
            MV006014: { name: "Meedhoo", adminLevel: "island" },
            MV006015: { name: "Kinolhas", adminLevel: "island" },
            MV006017: { name: "Gaaun'doodhoo", adminLevel: "island" },
            MV006018: { name: "Un'gulu", adminLevel: "island" },
            MV006019: { name: "Dhuvaafaru", adminLevel: "island" },
            MV006020: { name: "Aarah", adminLevel: "island" },
            MV006024: { name: "Bodufarufinolhu", adminLevel: "island" },
            MV006026: { name: "Bodufushi", adminLevel: "island" },
            MV006027: { name: "Boduhaiykodi", adminLevel: "island" },
            MV006028: { name: "Dheburidheythereyvaadhoo", adminLevel: "island" },
            MV006030: { name: "Dhigali", adminLevel: "island" },
            MV006035: { name: "Ehthigili", adminLevel: "island" },
            MV006037: { name: "Faarufushi", adminLevel: "island" },
            MV006039: { name: "Fasmendhoo", adminLevel: "island" },
            MV006040: { name: "Fenfushi", adminLevel: "island" },
            MV006041: { name: "Filaidhoo", adminLevel: "island" },
            MV006042: { name: "Fuggiri", adminLevel: "island" },
            MV006043: { name: "Furaveri", adminLevel: "island" },
            MV006052: { name: "Huruvalhi", adminLevel: "island" },
            MV006053: { name: "Ifuru", adminLevel: "island" },
            MV006055: { name: "Kan'doogan'du", adminLevel: "island" },
            MV006057: { name: "Kottefaru", adminLevel: "island" },
            MV006059: { name: "Kudafushi", adminLevel: "island" },
            MV006060: { name: "Kudakurathu", adminLevel: "island" },
            MV006066: { name: "Kuroshigiri", adminLevel: "island" },
            MV006093: { name: "Lhohi", adminLevel: "island" },
            MV006094: { name: "Lin'boakandhoo", adminLevel: "island" },
            MV006095: { name: "Lun'dhufushi", adminLevel: "island" },
            MV006096: { name: "Maamin'gili", adminLevel: "island" },
            MV006097: { name: "Maamunagau", adminLevel: "island" },
            MV006099: { name: "Maanenfushi", adminLevel: "island" },
            MV006103: { name: "Meedhupparu", adminLevel: "island" },
            MV006106: { name: "Muravandhoo", adminLevel: "island" },
            MV006111: { name: "Uthurumaafaru", adminLevel: "island" },
            MV006116: { name: "Veyvah", adminLevel: "island" }
        }
    },
    // Baa Atoll (MV007)
    MV007: {
        name: "Baa",
        adminLevel: "atoll",
        children: {
            MV007001: { name: "Kudarikilu", adminLevel: "island" },
            MV007002: { name: "Kamadhoo", adminLevel: "island" },
            MV007003: { name: "Kendhoo", adminLevel: "island" },
            MV007004: { name: "Kihaadhoo", adminLevel: "island" },
            MV007005: { name: "Dhonfanu", adminLevel: "island" },
            MV007006: { name: "Dharavandhoo", adminLevel: "island" },
            MV007007: { name: "Maalhos", adminLevel: "island" },
            MV007008: { name: "Eydhafushi", adminLevel: "island" },
            MV007009: { name: "Thulhaadhoo", adminLevel: "island" },
            MV007010: { name: "Hithaadhoo", adminLevel: "island" },
            MV007011: { name: "Fulhadhoo", adminLevel: "island" },
            MV007012: { name: "Fehendhoo", adminLevel: "island" },
            MV007013: { name: "Goidhoo", adminLevel: "island" },
            MV007015: { name: "Aidhoo", adminLevel: "island" },
            MV007021: { name: "Bodufinolhu", adminLevel: "island" },
            MV007022: { name: "Boifushi", adminLevel: "island" },
            MV007024: { name: "Dhandhoo", adminLevel: "island" },
            MV007026: { name: "Dhigudhefaru", adminLevel: "island" },
            MV007027: { name: "Dhigufaruvinagan'du", adminLevel: "island" },
            MV007029: { name: "Dhunikolhu", adminLevel: "island" },
            MV007030: { name: "En'boodhoo", adminLevel: "island" },
            MV007031: { name: "Fares", adminLevel: "island" },
            MV007032: { name: "Finolhas", adminLevel: "island" },
            MV007034: { name: "Fonimagoodhoo", adminLevel: "island" },
            MV007035: { name: "Funadhoo", adminLevel: "island" },
            MV007041: { name: "Hibalhidhoo", adminLevel: "island" },
            MV007042: { name: "Hirundhoo", adminLevel: "island" },
            MV007043: { name: "Horubadhoo", adminLevel: "island" },
            MV007045: { name: "Huraafaru", adminLevel: "island" },
            MV007046: { name: "Innafushi", adminLevel: "island" },
            MV007048: { name: "Kanufushi", adminLevel: "island" },
            MV007049: { name: "Kashidhoo", adminLevel: "island" },
            MV007051: { name: "Kihaadhuffaru", adminLevel: "island" },
            MV007052: { name: "Kihavahhuravalhi", adminLevel: "island" },
            MV007054: { name: "Kunfunadhoo", adminLevel: "island" },
            MV007055: { name: "Lan'daagiraavaru", adminLevel: "island" },
            MV007097: { name: "Maamaduvvari", adminLevel: "island" },
            MV007098: { name: "Maarikilu", adminLevel: "island" },
            MV007102: { name: "Mendhoo", adminLevel: "island" },
            MV007103: { name: "Milaidhoo", adminLevel: "island" },
            MV007104: { name: "Miriandhoo", adminLevel: "island" },
            MV007105: { name: "Mudhdhoo", adminLevel: "island" },
            MV007106: { name: "Muthaafushi", adminLevel: "island" },
            MV007110: { name: "Thiladhoo", adminLevel: "island" },
            MV007111: { name: "Ufuligiri", adminLevel: "island" },
            MV007112: { name: "Un'doodhoo", adminLevel: "island" },
            MV007113: { name: "Vakkaru", adminLevel: "island" },
            MV007118: { name: "Voavah", adminLevel: "island" }
        }
    },
    // Alifu Alifu Atoll (MV008)
    MV008: {
        name: "Alifu Alifu",
        adminLevel: "atoll",
        children: {
            MV008001: { name: "Thoddoo", adminLevel: "island" },
            MV008002: { name: "Rasdhoo", adminLevel: "island" },
            MV008003: { name: "Ukulhas", adminLevel: "island" },
            MV008004: { name: "Mathiveri", adminLevel: "island" },
            MV008005: { name: "Bodufolhudhoo", adminLevel: "island" },
            MV008006: { name: "Feridhoo", adminLevel: "island" },
            MV008007: { name: "Maalhos", adminLevel: "island" },
            MV008008: { name: "Himendhoo", adminLevel: "island" },
            MV008011: { name: "Bathalaa", adminLevel: "island" },
            MV008013: { name: "Ellaidhoo", adminLevel: "island" },
            MV008014: { name: "Etheremadivaru", adminLevel: "island" },
            MV008015: { name: "Fesdhoo", adminLevel: "island" },
            MV008019: { name: "Gaathafushi", adminLevel: "island" },
            MV008020: { name: "Gangehi", adminLevel: "island" },
            MV008021: { name: "Halaveli", adminLevel: "island" },
            MV008022: { name: "Kan'dholhudhoo", adminLevel: "island" },
            MV008023: { name: "Kudafolhudhoo", adminLevel: "island" },
            MV008024: { name: "Kuramathi", adminLevel: "island" },
            MV008037: { name: "Maagau", adminLevel: "island" },
            MV008038: { name: "Maayafushi", adminLevel: "island" },
            MV008041: { name: "Madoogali", adminLevel: "island" },
            MV008042: { name: "Mathivereefinolhu", adminLevel: "island" },
            MV008043: { name: "Mushimasmigili", adminLevel: "island" },
            MV008044: { name: "Velidhoo", adminLevel: "island" },
            MV008046: { name: "Veligan'du", adminLevel: "island" }
        }
    },
    // Kaafu Atoll (MV009)
    MV009: {
        name: "Kaafu",
        adminLevel: "atoll",
        children: {
            MV009001: { name: "Kaashidhoo", adminLevel: "island" },
            MV009002: { name: "Gaafaru", adminLevel: "island" },
            MV009003: { name: "Dhiffushi", adminLevel: "island" },
            MV009004: { name: "Thulusdhoo", adminLevel: "island" },
            MV009005: { name: "Huraa", adminLevel: "island" },
            MV009006: { name: "Hinmafushi", adminLevel: "island" },
            MV009007: { name: "Gulhi", adminLevel: "island" },
            MV009008: { name: "Maafushi", adminLevel: "island" },
            MV009009: { name: "Guraidhoo", adminLevel: "island" },
            MV009010: { name: "Aanugan'dufinolhu", adminLevel: "island" },
            MV009011: { name: "Aanugan'duhuraa", adminLevel: "island" },
            MV009012: { name: "Aarah", adminLevel: "island" },
            MV009013: { name: "Akasdhoo", adminLevel: "island" },
            MV009014: { name: "Akirifushi", adminLevel: "island" },
            MV009015: { name: "Asdhoo", adminLevel: "island" },
            MV009016: { name: "Baros", adminLevel: "island" },
            MV009017: { name: "Biyaadhoo", adminLevel: "island" },
            MV009018: { name: "Boduban'dos", adminLevel: "island" },
            MV009020: { name: "Bodufinolhu", adminLevel: "island" },
            MV009021: { name: "Boduhithi", adminLevel: "island" },
            MV009022: { name: "Boduhuraa", adminLevel: "island" },
            MV009023: { name: "Bolifushi", adminLevel: "island" },
            MV009025: { name: "Dhigufinolhu", adminLevel: "island" },
            MV009026: { name: "Dhonfushi", adminLevel: "island" },
            MV009027: { name: "Dhoonidhoo", adminLevel: "island" },
            MV009028: { name: "Ehmafushi", adminLevel: "island" },
            MV009029: { name: "En'boodhoo", adminLevel: "island" },
            MV009030: { name: "En'boodhoofinolhu", adminLevel: "island" },
            MV009031: { name: "Eriadhoo", adminLevel: "island" },
            MV009032: { name: "Erruhhuraa", adminLevel: "island" },
            MV009037: { name: "Farukolhufushi", adminLevel: "island" },
            MV009038: { name: "Feydhoofinolhu", adminLevel: "island" },
            MV009039: { name: "Fihaalhohi", adminLevel: "island" },
            MV009041: { name: "Funfinolhu", adminLevel: "island" },
            MV009042: { name: "Furanafushi", adminLevel: "island" },
            MV009044: { name: "Gasfinolhu", adminLevel: "island" },
            MV009045: { name: "Giraavaru", adminLevel: "island" },
            MV009046: { name: "Girifushi", adminLevel: "island" },
            MV009047: { name: "Gulhigaathuhuraa", adminLevel: "island" },
            MV009048: { name: "Hastheem", adminLevel: "island" },
            MV009049: { name: "Hathaafinolhu", adminLevel: "island" },
            MV009050: { name: "Helen'geli", adminLevel: "island" },
            MV009051: { name: "Hen'badhoo", adminLevel: "island" },
            MV009052: { name: "Hulhule", adminLevel: "island" },
            MV009053: { name: "Ihuru", adminLevel: "island" },
            MV009055: { name: "Ithaafushi", adminLevel: "island" },
            MV009056: { name: "Kagi", adminLevel: "island" },
            MV009059: { name: "Kan'doomaafushi", adminLevel: "island" },
            MV009060: { name: "Kan'duoiygiri", adminLevel: "island" },
            MV009061: { name: "Kanifinolhu", adminLevel: "island" },
            MV009062: { name: "Kanuoiyhuraa", adminLevel: "island" },
            MV009064: { name: "Kohdhipparu", adminLevel: "island" },
            MV009065: { name: "Kudaban'dos", adminLevel: "island" },
            MV009066: { name: "Kudafinolhu", adminLevel: "island" },
            MV009069: { name: "Kudahuraa", adminLevel: "island" },
            MV009070: { name: "Lankanfinolhu", adminLevel: "island" },
            MV009071: { name: "Lankanfushi", adminLevel: "island" },
            MV009158: { name: "Lhohifushi", adminLevel: "island" },
            MV009160: { name: "Maadhoo", adminLevel: "island" },
            MV009161: { name: "Maaranfushi", adminLevel: "island" },
            MV009162: { name: "Madivaru", adminLevel: "island" },
            MV009163: { name: "Mahaanaelhihuraa", adminLevel: "island" },
            MV009165: { name: "Makunudhoo", adminLevel: "island" },
            MV009166: { name: "Makunufushi", adminLevel: "island" },
            MV009168: { name: "Medhufinolhu", adminLevel: "island" },
            MV009169: { name: "Meerufenfushi", adminLevel: "island" },
            MV009170: { name: "Nakahchaahuraa", adminLevel: "island" },
            MV009171: { name: "Nakaiychaafushi", adminLevel: "island" },
            MV009172: { name: "Nashvilu", adminLevel: "island" },
            MV009173: { name: "Noofinolhu", adminLevel: "island" },
            MV009174: { name: "Olhigan'dufinolhu", adminLevel: "island" },
            MV009175: { name: "Olhuhali", adminLevel: "island" },
            MV009176: { name: "Olhuveli", adminLevel: "island" },
            MV009177: { name: "Rannaalhi", adminLevel: "island" },
            MV009181: { name: "Tholhimaraahuraa", adminLevel: "island" },
            MV009182: { name: "Thulhaagiri", adminLevel: "island" },
            MV009184: { name: "Thun'bafushi", adminLevel: "island" },
            MV009185: { name: "Vaadhoo", adminLevel: "island" },
            MV009186: { name: "Vaagali", adminLevel: "island" },
            MV009187: { name: "Vabbinfaru", adminLevel: "island" },
            MV009190: { name: "Velassaru", adminLevel: "island" },
            MV009191: { name: "Veligan'duhuraa", adminLevel: "island" },
            MV009192: { name: "Vihamanaafushi", adminLevel: "island" },
            MV009193: { name: "Vilin'gilimathidhahuraa", adminLevel: "island" },
            MV009194: { name: "Villivaru", adminLevel: "island" },
            MV009195: { name: "Ziyaaraiyfushi", adminLevel: "island" }
        }
    },
    // Vaavu Atoll (MV010)
    MV010: {
        name: "Vaavu",
        adminLevel: "atoll",
        children: {
            MV010001: { name: "Fulidhoo", adminLevel: "island" },
            MV010002: { name: "Thinadhoo", adminLevel: "island" },
            MV010003: { name: "Felidhoo", adminLevel: "island" },
            MV010004: { name: "Keyodhoo", adminLevel: "island" },
            MV010005: { name: "Rakeedhoo", adminLevel: "island" },
            MV010006: { name: "Aarah", adminLevel: "island" },
            MV010007: { name: "Alimathaa", adminLevel: "island" },
            MV010008: { name: "Anbaraa", adminLevel: "island" },
            MV010009: { name: "Bodumohoraa", adminLevel: "island" },
            MV010011: { name: "Fohtheyobodufushi", adminLevel: "island" },
            MV010012: { name: "Hulhidhoo", adminLevel: "island" },
            MV010015: { name: "Kunaaveshi", adminLevel: "island" }
        }
    },
    // Faafu Atoll (MV011)
    MV011: {
        name: "Faafu",
        adminLevel: "atoll",
        children: {
            MV011001: { name: "Feeali", adminLevel: "island" },
            MV011002: { name: "Bileiydhoo", adminLevel: "island" },
            MV011003: { name: "Magoodhoo", adminLevel: "island" },
            MV011004: { name: "Dharan'boodhoo", adminLevel: "island" },
            MV011005: { name: "Nilandhoo", adminLevel: "island" },
            MV011008: { name: "En'bulufushi", adminLevel: "island" },
            MV011010: { name: "Filitheyo", adminLevel: "island" },
            MV011011: { name: "Himithi", adminLevel: "island" },
            MV011012: { name: "Jinnathugau", adminLevel: "island" },
            MV011028: { name: "Maafushi", adminLevel: "island" },
            MV011032: { name: "Minimasgali", adminLevel: "island" }
        }
    },
    // Dhaalu Atoll (MV012)
    MV012: {
        name: "Dhaalu",
        adminLevel: "atoll",
        children: {
            MV012001: { name: "Meedhoo", adminLevel: "island" },
            MV012002: { name: "Ban'didhoo", adminLevel: "island" },
            MV012003: { name: "Rin'budhoo", adminLevel: "island" },
            MV012004: { name: "Hulhudheli", adminLevel: "island" },
            MV012007: { name: "Maaen'boodhoo", adminLevel: "island" },
            MV012008: { name: "Kudahuvadhoo", adminLevel: "island" },
            MV012009: { name: "Aluvifushi", adminLevel: "island" },
            MV012011: { name: "Boarikifinolhu", adminLevel: "island" },
            MV012015: { name: "Dhoores", adminLevel: "island" },
            MV012016: { name: "En'boodhoofushi", adminLevel: "island" },
            MV012017: { name: "Faandhoo", adminLevel: "island" },
            MV012020: { name: "Hiriyafushi", adminLevel: "island" },
            MV012024: { name: "Kan'dinmaa", adminLevel: "island" },
            MV012026: { name: "Kedhigan'du", adminLevel: "island" },
            MV012052: { name: "Lhohi", adminLevel: "island" },
            MV012054: { name: "Maafushi", adminLevel: "island" },
            MV012055: { name: "Maagau", adminLevel: "island" },
            MV012057: { name: "Meedhuffushi", adminLevel: "island" },
            MV012060: { name: "Olhuveli", adminLevel: "island" },
            MV012065: { name: "Uhdhoo", adminLevel: "island" },
            MV012068: { name: "Velavaru", adminLevel: "island" },
            MV012069: { name: "Vommuli", adminLevel: "island" }
        }
    },
    // Meemu Atoll (MV013)
    MV013: {
        name: "Meemu",
        adminLevel: "atoll",
        children: {
            MV013001: { name: "Raiymandhoo", adminLevel: "island" },
            MV013002: { name: "Madifushi", adminLevel: "island" },
            MV013003: { name: "Veyvah", adminLevel: "island" },
            MV013004: { name: "Mulah", adminLevel: "island" },
            MV013005: { name: "Muli", adminLevel: "island" },
            MV013006: { name: "Naalaafushi", adminLevel: "island" },
            MV013007: { name: "Kolhufushi", adminLevel: "island" },
            MV013008: { name: "Dhiggaru", adminLevel: "island" },
            MV013009: { name: "Maduvvari", adminLevel: "island" },
            MV013010: { name: "Boahuraa", adminLevel: "island" },
            MV013012: { name: "Dhekunuboduveli", adminLevel: "island" },
            MV013016: { name: "Fenfuraaveli", adminLevel: "island" },
            MV013017: { name: "Gaakurali", adminLevel: "island" },
            MV013018: { name: "Gasveli", adminLevel: "island" },
            MV013020: { name: "Hakuraahuraa", adminLevel: "island" },
            MV013022: { name: "Hurasveli", adminLevel: "island" },
            MV013024: { name: "Kekuraalhuveli", adminLevel: "island" },
            MV013025: { name: "Kudausfushi", adminLevel: "island" },
            MV013058: { name: "Maausfushi", adminLevel: "island" },
            MV013059: { name: "Medhufushi", adminLevel: "island" },
            MV013061: { name: "Seedheehuraa", adminLevel: "island" },
            MV013062: { name: "Seedheehuraaveligan'du", adminLevel: "island" },
            MV013063: { name: "Thuvaru", adminLevel: "island" },
            MV013065: { name: "Uthuruboduveli", adminLevel: "island" },
            MV013066: { name: "Uthurugaseveli", adminLevel: "island" }
        }
    },
    // Thaa Atoll (MV014)
    MV014: {
        name: "Thaa",
        adminLevel: "atoll",
        children: {
            MV014001: { name: "Burunee", adminLevel: "island" },
            MV014002: { name: "Vilufushi", adminLevel: "island" },
            MV014003: { name: "Madifushi", adminLevel: "island" },
            MV014004: { name: "Dhiyamigili", adminLevel: "island" },
            MV014005: { name: "Guraidhoo", adminLevel: "island" },
            MV014006: { name: "Kan'doodhoo", adminLevel: "island" },
            MV014007: { name: "Vandhoo", adminLevel: "island" },
            MV014008: { name: "Hirilandhoo", adminLevel: "island" },
            MV014009: { name: "Gaadhiffushi", adminLevel: "island" },
            MV014010: { name: "Thimarafushi", adminLevel: "island" },
            MV014011: { name: "Veymandoo", adminLevel: "island" },
            MV014012: { name: "Kin'bidhoo", adminLevel: "island" },
            MV014013: { name: "Omadhoo", adminLevel: "island" },
            MV014018: { name: "Dhururehaa", adminLevel: "island" },
            MV014019: { name: "Ekuruffushi", adminLevel: "island" },
            MV014020: { name: "Elaa", adminLevel: "island" },
            MV014025: { name: "Funaddu", adminLevel: "island" },
            MV014034: { name: "Kaaddoo", adminLevel: "island" },
            MV014037: { name: "Kalhudheyfushi", adminLevel: "island" },
            MV014041: { name: "Kanimeedhoo", adminLevel: "island" },
            MV014064: { name: "Maalefushi", adminLevel: "island" },
            MV014068: { name: "Olhufushi", adminLevel: "island" },
            MV014069: { name: "Olhufushifinolhu", adminLevel: "island" },
            MV014070: { name: "Olhugiri", adminLevel: "island" },
            MV014072: { name: "Ruhthibirah", adminLevel: "island" }
        }
    },
    // Laamu Atoll (MV015)
    MV015: {
        name: "Laamu",
        adminLevel: "atoll",
        children: {
            MV015001: { name: "Isdhoo", adminLevel: "island" },
            MV015002: { name: "Dhan'bidhoo", adminLevel: "island" },
            MV015003: { name: "Maabaidhoo", adminLevel: "island" },
            MV015004: { name: "Mundoo", adminLevel: "island" },
            MV015005: { name: "Kalaidhoo", adminLevel: "island" },
            MV015007: { name: "Maavah", adminLevel: "island" },
            MV015008: { name: "Fonadhoo", adminLevel: "island" },
            MV015009: { name: "Gaadhoo", adminLevel: "island" },
            MV015010: { name: "Maamendhoo", adminLevel: "island" },
            MV015011: { name: "Hithadhoo", adminLevel: "island" },
            MV015012: { name: "Kunahandhoo", adminLevel: "island" },
            MV015013: { name: "Gan", adminLevel: "island" },
            MV015016: { name: "Baresdhoo", adminLevel: "island" },
            MV015018: { name: "Bodufinolhu", adminLevel: "island" },
            MV015019: { name: "Bodufinolhu", adminLevel: "island" },
            MV015021: { name: "Boduhuraa", adminLevel: "island" },
            MV015030: { name: "Fares", adminLevel: "island" },
            MV015036: { name: "Guraidhoo", adminLevel: "island" },
            MV015037: { name: "Haiythoshi", adminLevel: "island" },
            MV015045: { name: "Kadhdhoo", adminLevel: "island" },
            MV015048: { name: "Kandaru", adminLevel: "island" },
            MV015050: { name: "Kashidhoo", adminLevel: "island" },
            MV015053: { name: "Kudafushi", adminLevel: "island" },
            MV015078: { name: "Maandhoo", adminLevel: "island" },
            MV015080: { name: "Mahakanfushi", adminLevel: "island" },
            MV015082: { name: "Mendhoo", adminLevel: "island" },
            MV015084: { name: "Olhuveli", adminLevel: "island" },
            MV015090: { name: "Vadinolhu", adminLevel: "island" }
        }
    },
    // Gaafu Alifu Atoll (MV016)
    MV016: {
        name: "Gaafu Alifu",
        adminLevel: "atoll",
        children: {
            MV016001: { name: "Kolamaafushi", adminLevel: "island" },
            MV016002: { name: "Vilin'gili", adminLevel: "island" },
            MV016003: { name: "Maamendhoo", adminLevel: "island" },
            MV016004: { name: "Nilandhoo", adminLevel: "island" },
            MV016005: { name: "Dhaandhoo", adminLevel: "island" },
            MV016006: { name: "Dhevvadhoo", adminLevel: "island" },
            MV016007: { name: "Kon'dey", adminLevel: "island" },
            MV016009: { name: "Gemanafushi", adminLevel: "island" },
            MV016010: { name: "Kan'duhulhudhoo", adminLevel: "island" },
            MV016014: { name: "Bakehthaa", adminLevel: "island" },
            MV016022: { name: "Dhevvalaabadhoo", adminLevel: "island" },
            MV016024: { name: "Dhigurah", adminLevel: "island" },
            MV016025: { name: "Falhumaafushi", adminLevel: "island" },
            MV016031: { name: "Funadhoo", adminLevel: "island" },
            MV016032: { name: "Funadhooviligillaa", adminLevel: "island" },
            MV016033: { name: "Funamauddaa", adminLevel: "island" },
            MV016035: { name: "Han'dahaa", adminLevel: "island" },
            MV016036: { name: "Hinaamaagalaa", adminLevel: "island" },
            MV016037: { name: "Hirihuttaa", adminLevel: "island" },
            MV016039: { name: "Hithaadhoogalaa", adminLevel: "island" },
            MV016048: { name: "Keredhdhoo", adminLevel: "island" },
            MV016053: { name: "Kon'deymatheelaabadhoo", adminLevel: "island" },
            MV016054: { name: "Kooddoo", adminLevel: "island" },
            MV016066: { name: "LD1449", adminLevel: "island" },
            MV016088: { name: "Maamutaa", adminLevel: "island" },
            MV016089: { name: "Maarandhoo", adminLevel: "island" },
            MV016090: { name: "Maarehaa", adminLevel: "island" },
            MV016091: { name: "Mahahdhoo", adminLevel: "island" },
            MV016099: { name: "Meradhoo", adminLevel: "island" },
            MV016102: { name: "Raaverrehaa", adminLevel: "island" },
            MV016104: { name: "Vodamulaa", adminLevel: "island" }
        }
    },
    // Gaafu Dhaalu Atoll (MV017)
    MV017: {
        name: "Gaafu Dhaalu",
        adminLevel: "atoll",
        children: {
            MV017001: { name: "Madaveli", adminLevel: "island" },
            MV017002: { name: "Hoadehdhoo", adminLevel: "island" },
            MV017003: { name: "Nadellaa", adminLevel: "island" },
            MV017004: { name: "Gahdhoo", adminLevel: "island" },
            MV017005: { name: "Rathafandhoo", adminLevel: "island" },
            MV017006: { name: "Vaadhoo", adminLevel: "island" },
            MV017007: { name: "Fiyoari", adminLevel: "island" },
            MV017008: { name: "Faresmaathodaa", adminLevel: "island" },
            MV017010: { name: "Thinadhoo", adminLevel: "island" },
            MV017013: { name: "Kaadehdhoo", adminLevel: "island" },
            MV017026: { name: "Bolimathaidhoo", adminLevel: "island" },
            MV017034: { name: "Dhigurehaa", adminLevel: "island" },
            MV017039: { name: "Dhoonirehaa", adminLevel: "island" },
            MV017049: { name: "Farukolhuhuttaa", adminLevel: "island" },
            MV017053: { name: "Fereythavilin'gili", adminLevel: "island" },
            MV017058: { name: "Gazeeraa", adminLevel: "island" },
            MV017069: { name: "Havoddaa", adminLevel: "island" },
            MV017081: { name: "Kaashidhoo", adminLevel: "island" },
            MV017083: { name: "Kadevaarehaa", adminLevel: "island" },
            MV017084: { name: "Kadhefala", adminLevel: "island" },
            MV017104: { name: "Kodurataa", adminLevel: "island" },
            MV017105: { name: "Konottaa", adminLevel: "island" },
            MV017112: { name: "Kudherataa", adminLevel: "island" },
            MV017133: { name: "Lonudhoohuttaa", adminLevel: "island" },
            MV017139: { name: "Maallaarehaa", adminLevel: "island" },
            MV017143: { name: "Maavaaruloo", adminLevel: "island" },
            MV017144: { name: "Maavehdhoo", adminLevel: "island" },
            MV017145: { name: "Maguhdhuvaa", adminLevel: "island" },
            MV017156: { name: "Olhimuntaa", adminLevel: "island" },
            MV017160: { name: "Rahadhuvaa", adminLevel: "island" },
            MV017169: { name: "Vatavarrehaa", adminLevel: "island" }
        }
    },
    // Gnaviyani Atoll (MV018)
    MV018: {
        name: "Gnaviyani",
        adminLevel: "atoll",
        children: {
            MV018001: { name: "Fuvahmulah", adminLevel: "island" }
        }
    },
    // Seenu Atoll (MV019)
    MV019: {
        name: "Seenu",
        adminLevel: "atoll",
        children: {
            MV019001: { name: "Meedhoo", adminLevel: "island" },
            MV019002: { name: "Hithadhoo", adminLevel: "island" },
            MV019003: { name: "Maradhoo", adminLevel: "island" },
            MV019004: { name: "Feydhoo", adminLevel: "island" },
            MV019005: { name: "Maradhoofeydhoo", adminLevel: "island" },
            MV019006: { name: "Hulhudhoo", adminLevel: "island" },
            MV019025: { name: "Vilin'gili", adminLevel: "island" },
            MV019033: { name: "Gan", adminLevel: "island" },
            MV019034: { name: "Geskalhuheraa", adminLevel: "island" },
            MV019035: { name: "Gomahera", adminLevel: "island" },
            MV019036: { name: "Hankede", adminLevel: "island" },
            MV019038: { name: "Herethere", adminLevel: "island" },
            MV019040: { name: "Ismehelaahera", adminLevel: "island" },
            MV019057: { name: "Mulikede", adminLevel: "island" },
            MV019058: { name: "Savaaheli", adminLevel: "island" }
        }
    },
    // Alifu Dhaalu Atoll (MV020)
    MV020: {
        name: "Alifu Dhaalu",
        adminLevel: "atoll",
        children: {
            MV020001: { name: "Hangnaameedhoo", adminLevel: "island" },
            MV020002: { name: "Omadhoo", adminLevel: "island" },
            MV020003: { name: "Kun'burudhoo", adminLevel: "island" },
            MV020004: { name: "Mahibadhoo", adminLevel: "island" },
            MV020005: { name: "Mandhoo", adminLevel: "island" },
            MV020006: { name: "Dhan'gethi", adminLevel: "island" },
            MV020007: { name: "Dhigurah", adminLevel: "island" },
            MV020008: { name: "Fenfushi", adminLevel: "island" },
            MV020009: { name: "Dhihdhoo", adminLevel: "island" },
            MV020010: { name: "Maamin'gili", adminLevel: "island" },
            MV020011: { name: "Angaagau", adminLevel: "island" },
            MV020012: { name: "Ariyadhoo", adminLevel: "island" },
            MV020014: { name: "Athurugau", adminLevel: "island" },
            MV020015: { name: "Bodufinolhu", adminLevel: "island" },
            MV020018: { name: "Dhiffushi", adminLevel: "island" },
            MV020020: { name: "Dhihdhoofinolhu", adminLevel: "island" },
            MV020023: { name: "Heenfaru", adminLevel: "island" },
            MV020025: { name: "Hukurudhoo", adminLevel: "island" },
            MV020027: { name: "Huruelhi", adminLevel: "island" },
            MV020028: { name: "Huvahendhoo", adminLevel: "island" },
            MV020029: { name: "Innafushi", adminLevel: "island" },
            MV020032: { name: "Kudarah", adminLevel: "island" },
            MV020067: { name: "Lonuboi", adminLevel: "island" },
            MV020068: { name: "Maafushivaru", adminLevel: "island" },
            MV020069: { name: "Mahchafushi", adminLevel: "island" },
            MV020070: { name: "Mirihi", adminLevel: "island" },
            MV020071: { name: "Moofushi", adminLevel: "island" },
            MV020072: { name: "Nalaguraidhoo", adminLevel: "island" },
            MV020074: { name: "Rangaleefinolhu", adminLevel: "island" },
            MV020076: { name: "Theluveligaa", adminLevel: "island" },
            MV020077: { name: "Tholhifushi", adminLevel: "island" },
            MV020078: { name: "Thun'dufushi", adminLevel: "island" },
            MV020079: { name: "Vakarufalhi", adminLevel: "island" },
            MV020080: { name: "Vilamendhoo", adminLevel: "island" },
            MV020081: { name: "Vilin'gilivaru", adminLevel: "island" }
        }
    },
    // Male Atoll (MV021)
    MV021: {
        name: "Male",
        adminLevel: "atoll",
        children: {
            MV021001: { name: "Maale", adminLevel: "island" },
            MV021002: { name: "Vilin'gili", adminLevel: "island" },
            MV021003: { name: "Hulhumaale", adminLevel: "island" }
        }
    }
}

export const maldivesSeaAdministrativeLevel: AdministrativeLevels = {
    MLSAR01: {
        name: "Addu Atoll",
        adminLevel: "sea",
    },
    MLSAR02: {
        name: "Malé Atoll",
        adminLevel: "sea",
    },
    MLSAR03: {
        name: "Fuvahmulah",
        adminLevel: "sea",
    },
    MLSAR05: {
        name: "South Huvadhu Atoll",
        adminLevel: "sea",
    },
    MLSAR06: {
        name: "North Huvadhu Atoll",
        adminLevel: "sea",
    },
    MLSAR07: {
        name: "Hadhdhunmathi",
        adminLevel: "sea",
    },
    MLSAR08: {
        name: "Kolhumadulu",
        adminLevel: "sea",
    },
    MLSAR09: {
        name: "North Nilandhe Atoll",
        adminLevel: "sea",
    },
    MLSAR10: {
        name: "South Nilandhe Atoll",
        adminLevel: "sea",
    },
    MLSAR11: {
        name: "South Ari Atoll",
        adminLevel: "sea",
    },
    MLSAR12: {
        name: "North Ari Atoll",
        adminLevel: "sea",
    },
    MLSAR13: {
        name: "North Maalhosmadulu",
        adminLevel: "sea",
    },
    MLSAR14: {
        name: "Faadhippolhu",
        adminLevel: "sea",
    },
    MLSAR15: {
        name: "North Miladhunmadulu",
        adminLevel: "sea",
    },
    MLSAR16: {
        name: "South Miladhunmadulu",
        adminLevel: "sea",
    },
    MLSAR17: {
        name: "South Thiladhunmathi",
        adminLevel: "sea",
    },
    MLSAR18: {
        name: "North Thiladhunmathi",
        adminLevel: "sea",
    },
    /* // Gnaviyani Atoll (MV018)
    MV018: {
        name: "Gnaviyani",
        adminLevel: "atoll",
        children: {
            MV018001: { name: "Fuvahmulah", adminLevel: "island" }
        }
    },
    // Seenu Atoll (MV019)
    MV019: {
        name: "Seenu",
        adminLevel: "atoll",
    },
    // Alifu Dhaalu Atoll (MV020)
    MV020: {
        name: "Alifu Dhaalu",
        adminLevel: "atoll",
    },
    // Male Atoll (MV021)
    MV021: {
        name: "Male",
        adminLevel: "atoll",
    } */
}

export const warningMap = new Map<string, string>([
    ["HRW", "Heavy rain warning"],
    ["HWN", "High wind warning"],
    ["FLW", "Flood warning"],
    ["LIG", "Severe lightning warning"],
    ["LSW", "Land slide warning"],
    ["SAN", "Marine weather warning"],
    ["TSM", "Tsunami warning"],
    ["CUS", "Custom warning"],
    ["GUS", "Gust warning"],
  ])

export const getAdminLevelByCode = (areaCode: string): string =>  {
    for (const provinceKey in maldivesAdministrativeLevel) {
        const province = maldivesAdministrativeLevel[provinceKey];

        // Province-level match
        if (provinceKey === areaCode) {
            return province.adminLevel;
        }

        // Check districts
        for (const districtKey in province.children) {
            const district = province.children[districtKey];

            if (districtKey === areaCode) {
                return district.adminLevel;
            }

            // Check DS divisions
            for (const dsKey in district.children) {
                const ds = district.children[dsKey];

                if (dsKey === areaCode) {
                    return ds.adminLevel;
                }
            }
        }
    }
    return ""; // default if not found
}